import request from "_private/utils/request";

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchByPage(data) {
    return request({
        url: "/base/downloadCenter/findByPage",
        method: "post",
        headers: {type: "json"},
        data
    });
}

/**
 * 保存
 * @param {*} data
 */
export function SaveDownloadFileInfo(data) {
    return request({
        url: "/base/downloadCenter/saveDownloadFileInfo",
        method: "post",
        headers: {type: "json"},
        data
    });
}


/**
 * 删除
 * @param {*} data
 */
export function DeleteFileInfo(data) {
    return request({
        url: "/base/downloadCenter/deleteFileInfo",
        method: "post",
        data
    });
}

export function DownloadFile(data){
    return request({
        url: "/app/file/download",
        method: "post",
        data
    });
}


